import React, { memo, FC } from "react";
import Typography from "@mui/material/Typography";
import { convertDecimalToFraction } from "../../util/formulas/convertDecimalToFraction";
import ReusableAccordian from "../ReusableAccordion";
import SizeLayout from "../SizeLayout";
import PleaseNote from "../PleaseNote";
import { RowLayout, ColLayout } from "../../util/accordianStyles";
import useHeightSelector from "./useHeightSelector";

interface HeightProps {
  showHandleHeight: (show: boolean) => void;
}

const HeightAccordian: FC<HeightProps> = ({ showHandleHeight }) => {
  const {
    handleHeightChange,
    handleFractionChange,
    swingPanelHeight,
    heightErr,
    doorType,
    height,
    heightFraction,
    // alumSideliteHeight,
    isAlum
  } = useHeightSelector(showHandleHeight);

  return (
    <ReusableAccordian
      accordionName="height"
      heading="Net Frame Height"
      secondaryHeading="Select a Height"
      required5={true}
    >
      <ColLayout style={{ maxWidth: 600 }}>
        {doorType?.includes("Bi-fold") && isAlum ? (
          <PleaseNote
            intro="Recommended Net Frame Height clearance is as follows:"
            notes={[
              "1/2 inch less than the Rough Opening Height for Raised Sill and Ramp Sill",
              "1-5/16 inches less than the RO Height for Embedded Sill",
              "1-5/8 inches less than the RO Height for Low Profile Sill",
            ]}
          />
        )
        : doorType.includes("Bi-fold") ? (
          <PleaseNote
            intro="Recommended Net Frame Height clearance is as follows:"
            notes={[
              "1/2 inch less than the Rough Opening Height for Raised Sills",
              "1-3/8 inches less than the RO Height for Ultra Guide tracks",
              "1-5/8 inches less than the RO Height for Ultra Guide tracks with a Brio accordion Screen",
              "2-1/4 inches less than the RO Height for Ultra Guide tracks with a Centor Flat Screen/Shade",
            ]}
          />
        ) : doorType === "Slider" ? (
          <PleaseNote notes="Recommended Net Frame Height clearance is as follows: 1/2 inch less than the Rough Opening Height for Raised Sills, and 1-3/4 inches for Stainless Steel tracks." />
        ) : (
          <PleaseNote notes="We recommend Net Frame Height to be 1/2 inch less than the Rough Opening Height" />
        )}

        <RowLayout>
          <SizeLayout
            size={height}
            handleChange={handleHeightChange}
            sizeErr={heightErr}
            name="height"
            fractionValue={heightFraction || ""}
            handleFractionChange={handleFractionChange}
          />
        </RowLayout>

        {height && swingPanelHeight && doorType === "Swing" ? (
          <>
            <RowLayout>
              <Typography
                style={{
                  color: "#3f51b5",
                  fontWeight: "bold",
                  paddingRight: 10,
                }}
              >
                Panel Height:{" "}
              </Typography>
              <Typography>
                {convertDecimalToFraction(swingPanelHeight)} inches
              </Typography>
            </RowLayout>

            {/* {alumSideliteHeight ? (
              <RowLayout style={{ padding: 0, margin: 0 }}>
                <Typography
                  style={{
                    color: "#3f51b5",
                    fontWeight: "bold",
                    paddingRight: 10,
                  }}
                >
                  Sidelite Height:{" "}
                </Typography>
                <Typography>
                  {convertDecimalToFraction(alumSideliteHeight)} inches
                </Typography>
              </RowLayout>
            ) : null} */}
          </>
        ) : null}
      </ColLayout>
    </ReusableAccordian>
  );
};

export default memo(HeightAccordian);
